export default __webpack_public_path__ + "static/media/react.65ca18b4.png";